<template>
  <!-- v-loading="loading" element-loading-text="拼命加载中" -->
  <div class="template_spacing height vertical_layout">
    <breadcrumbModule :nav-data="navData"></breadcrumbModule>
    <div class="bm_spacing">
      <searchTop>
        <template #search>
          <el-form class="demo-ruleForm" style="display: flex">
            <el-form-item prop="deviceName">
              <el-input v-model="param.deviceName" placeholder="请输入设备名称搜索" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item prop="telType">
              <el-select v-model="param.status" placeholder="设备通信状态" style="position: relative; width: 150px">
                <el-option label="在线" value="0"></el-option>
                <el-option label="离线" value="1"></el-option>
              </el-select>
            </el-form-item>
            <div class="abnormalState rm_spacing" style="padding-top: 10px">
              <span class="abnormalStateSpan" @click="isAlert">异常状态</span>
              <span
                class="abnormalStateSpan"
                style="
                  background-color: #ccc;
                  display: inline-block;
                  width: 40px;
                  height: 24px;
                  line-height: 24px;
                  color: white;
                  border-radius: 12px;
                  margin-right: 15px;
                  text-align: center;
                "
                >0</span
              >
              <el-button icon="el-icon-document-copy" @click="dialogVisible = true" class="abnormalRed">历史异常记录</el-button>
              <el-dialog class="elDialogAdd indexJust" title="历史异常记录" top="0" :visible.sync="dialogVisible" width="60%">
                <div style="width: 100%; overflow-x: auto">
                  <noDataOrLoading :listData="historyList" :loading="curLoading"></noDataOrLoading>
                  <el-table class="elTableModule" :data="historyList" height="450" fixed style="text-align: center">
                    <el-table-column type="index" label="序号" align="center" width="65"></el-table-column>
                    <el-table-column prop="createTime" width="190" align="center" label="异常发生时间"></el-table-column>
                    <el-table-column prop="deviceName" label="设备名称	"></el-table-column>
                    <el-table-column prop="mintagunit" width="160" align="center" label="监测类型	">
                      <div>体温监测</div>
                    </el-table-column>
                    <el-table-column prop="videoThumb" width="200" align="center" label="异常画面">
                      <template slot-scope="scope">
                        <img class="alertImg" :src="scope.row.videoThumb" alt @error="imgError1($event, scope.row)" />
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-dialog>
            </div>
          </el-form>
        </template>
        <template #operation>
          <div class="horizontal_layout">
            <el-button
              v-for="(btn, btnIndex) in resetOrSearch"
              :key="btnIndex"
              :icon="btn.icon"
              :class="btn.class"
              @click="searchEvent(btn)"
              >{{ btn.title }}</el-button
            >
          </div>
        </template>
      </searchTop>
    </div>
    <div class="flex height template_back tblr_spacing template_radius overflow">
      <tableTitleModule :tableTitleData="tableTitleData" :total="total" :key="total" @exportData="downloadFlexFlow()"></tableTitleModule>
      <div class="vertical_layout pdaModule tableHeight y_scroll">
        <!-- 为空或者加载 -->
        <noDataOrLoading
          :listData="video_msg"
          :loading="curLoading"
          :relative="true"
          v-if="video_msg.length === 0 || curLoading"
        ></noDataOrLoading>
        <!-- 视频内容 -->
        <div class="flex height" v-if="video_msg.length > 0 && !curLoading">
          <div class="height horizontal_layout">
            <div class="detailViewNews" :style="[detailViewNewPlayer]" v-for="(item, index) in video_msg" :key="index">
              <!-- 之前的方法 imgPlayBtn -->
              <div class="layui-player-el" :style="[layuiPlayerHeightJson]" v-if="item.imgUrl" @click="toDetail(item)">
                <easyplayerVideo :camera="item" v-if="item.videoSrc"></easyplayerVideo>
                <el-image v-else style="width: 100%; height: 100%" :src="item.imgUrl"></el-image>
              </div>
              <div class="layui-player-el" :style="[layuiPlayerHeightJson]" v-else>
                <el-image style="width: 100%; height: 100%" src="./../../../static/images/default.png"></el-image>
              </div>
              <div class="itemOnDuty" v-if="item.algorithmMonitoringStatus == 0">
                <section>
                  <img src="@/assets/img/openai.svg" />
                  <span>{{ item.algorithmMonitoringValue }}</span>
                </section>
              </div>
              <div class="itemOnDuty itemOnDutyNull" v-if="item.algorithmMonitoringStatus == 1">
                <section>
                  <img src="@/assets/img/u717.png" />
                  <span>{{ item.algorithmMonitoringValue }}</span>
                </section>
              </div>
              <div class="itemOnDuty itemOnDutyErr" v-if="item.algorithmMonitoringStatus == 2">
                <section>
                  <img src="@/assets/img/u717.png" />
                  <span>{{ item.algorithmMonitoringValue }}</span>
                </section>
              </div>
              <div class="info">
                <div class="titles text-">
                  <div class="titles-name">
                    {{ item.deviceName }}
                  </div>
                  <div>
                    <el-button icon="el-icon-document" class="btReset" @click="toDetail(item)" style="padding: 6px 10px">查看</el-button>
                  </div>
                </div>
                <div class="infoDatas">
                  <div v-for="(val, i) in item.algorithmTypeVoList" :key="i" class="infoDatas-flex">
                    <!-- {{ val.algorithmStatus }} {{ val.value }} -->
                    <div>
                      {{ val.algorithmName }}：
                      <span
                        v-if="(val.algorithmStatus == 0 && val.algorithmType == 4) || (val.algorithmStatus == 0 && val.algorithmType == 5)"
                        >{{ val.value }}</span
                      >
                      <span
                        v-if="val.algorithmStatus == 0 && val.algorithmType != 4 && val.algorithmStatus == 0 && val.algorithmType != 5"
                        style="color: #00bf30"
                        >{{ val.value }}</span
                      >
                      <span v-if="val.algorithmStatus == 1" style="color: #d92121">{{ val.value }}</span>
                      <span v-if="val.algorithmStatus == 2">{{ val.value || '未开通' }}</span>
                    </div>
                  </div>
                  <!-- <div>
                    <div>
                      体温监测：
                      <span :style="{ color: item.animalHeat == 1 ? 'red' : '#30BF30' }">
                        {{ item.animalHeat == 1 ? '异常' : '正常' }}
                      </span>
                      <span>未开通</span>
                    </div>
                    <div>
                      繁殖优化：
                      <span style="color: #00bf30" v-if="item.openAlgo">已开通</span>
                      <span v-else>未开通</span>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <paginationEL
        :total="total"
        :totalStatus="true"
        :pageCurrent="param.current"
        :pageSize="param.size"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></paginationEL>
    </div>
    <!-- 查看详情dialog -->
    <div class="maskCover" v-if="dialogVisible1" @click="closeDialog"></div>
    <div class="coverBlock" v-if="dialogVisible1">
      <div class="coverTop over_h">
        <div class="fl lh_40 deviceNameTitle">查看详情</div>
        <div class="fr topTab over_h">
          <div class="fl" :class="tabHeadIndex == 0 ? 'topTabCur' : ''" @click="tabHeader(0)">实时画面</div>
          <div class="fl mar_l10" :class="tabHeadIndex == 1 ? 'topTabCur' : ''" @click="tabHeader(1)">历史录像</div>
        </div>
        <a class="layuiColse" @click="closeDialog"></a>
      </div>
      <div class="coverImg viewer-images" v-if="tabHeadIndex == 0">
        <div class="videoCover_a">
          <!-- <img
            v-if="leftIndex != 0 && zcItem"
            id="zoomImgs"
            style="vertical-align: inherit !important; width: 615px"
            :src="zcItem.checkImg || zcItem.alarmImg"
            class="zcImgs zoomImg viewer-toggle"
          /> -->
          <el-image
            ref="preview"
            v-if="leftIndex != 0 && zcItem"
            style="width: 100%; height: 100%"
            :src="zcItem.checkImg || zcItem.alarmImg"
            :preview-src-list="previewSrclist(zcItem.checkImg || zcItem.alarmImg)"
            fit="cover"
            class="zcImgs zoomImg viewer-toggle"
          ></el-image>
          <easyplayerVideo :camera="camera"></easyplayerVideo>
          <div
            @click="handlePreview"
            v-if="leftIndex != 0 && zcItem"
            style="
              position: absolute;
              right: 6px;
              bottom: 6px;
              color: #fff;
              font-size: 18px;
              cursor: pointer;
              pointer-events: auto;
              z-index: 99999;
            "
          >
            <i class="el-icon-full-screen"></i>
          </div>
        </div>

        <div class="markeT"></div>
        <div class="over_h" style="height: 200px; margin-top: 20px">
          <div class="fl tabTitle">
            <template v-for="item in detailInfo.algorithmTypeVoList">
              <div
                :class="leftIndex == item.algorithmType ? 'tabTitleCur' : ''"
                @click="tabLeft(item)"
                v-if="item.algorithmType == 0"
                :key="item.algorithmType"
              >
                {{ item.algorithmName }}
              </div>

              <div
                class="over_h"
                :class="leftIndex == item.algorithmType ? 'tabTitleCur' : ''"
                @click="tabLeft(item)"
                v-else
                :key="item.leftIndex"
              >
                <div class="fl">{{ item.algorithmName }}</div>
                <div class="fr zcNum lh21" v-if="detailInfo.algorithmMonitoringStatus != 1">
                  {{ item.value || '0' }}
                </div>
                <div class="fr zcNum lh21" v-else>未开通</div>
              </div>
            </template>
          </div>
          <!-- 设备编辑 -->
          <div class="fl over_h tabContent" :key="leftIndex">
            <div class="fl show tabCurContent padd_lr20" style="width: 400px" v-if="leftIndex == 0">
              <div class="editDevice" @click="editClick">设备编辑</div>
              <div class="over_h RealContent">
                <div class="fl" style="width: 100px">设备名称</div>
                <div class="fl deviceNameT">{{ detailInfo.deviceName }}</div>
              </div>
              <div class="over_h RealContent">
                <div class="fl" style="width: 100px">种类</div>
                <div class="fl typeT" v-if="detailInfo.livestockType == 0">其他</div>
                <div class="fl typeT" v-if="detailInfo.livestockType == 1">羊</div>
                <div class="fl typeT" v-if="detailInfo.livestockType == 2">猪</div>
                <div class="fl typeT" v-if="detailInfo.livestockType == 3">牛</div>
                <div class="fl typeT" v-if="detailInfo.livestockType == 4">驴</div>
                <div class="fl typeT" v-if="detailInfo.livestockType == 5">鸡</div>
              </div>
              <!-- <div class="over_h RealContent">
                  <div class="fl" style="width: 100px">圈舍类型</div>
                  <div class="fl deviceTypeT">未绑定</div>
                </div> -->
            </div>
            <div class="fl tabCurContent over_h" style="width: 448px" v-if="leftIndex == 4">
              <div class="fl padd_lr20" v-if="detailInfo.algorithmMonitoringStatus != 1">
                <div class="over_h dateTitle">
                  <form class="layui-form">
                    <div class="layui-input-inline">
                      <el-date-picker
                        value-format="yyyy-MM-dd"
                        @change="changezcpd"
                        v-model="zcpdDate"
                        type="date"
                        placeholder="选择时间"
                      ></el-date-picker>
                    </div>
                  </form>
                </div>
                <div class="border borderZC">
                  <!-- <div v-if="i==0" :class="zcIndex==i?'on':''" class="over_h " @click="tabZc(i,item)"><div class="fl">{{item.createTime}}</div> <div class="fr">最大</div></div> -->
                  <div
                    v-show="checkList.length > 0"
                    v-for="(item, i) in checkList"
                    :class="zcIndex == i ? 'on' : ''"
                    class="over_h"
                    @click="tabZc(i, item)"
                    :key="i"
                  >
                    <div class="fl">{{ item.createTime }}</div>
                    <div class="fr">{{ item.checkCount === leftItem.value ? '最大' : item.checkCount }}</div>
                  </div>
                  <div v-if="checkList.length < 1" style="line-height: 30px; text-align: left">暂未发现</div>
                </div>
              </div>
              <div class="fr" style="width: 238px; position: relative; height: 200px" v-if="detailInfo.algorithmMonitoringStatus != 1">
                <div class="over_h lh40">
                  <div class="fl RealContent lh40" style="width: 80px">盘点数量</div>
                  <div class="fl deviceNumber">{{ zcItem ? zcItem.checkCount : '0' }}</div>
                </div>
                <div class="over_h lh40">
                  <div class="fl RealContent lh40" style="width: 80px">消息提醒</div>
                  <div class="fl typeInfo">
                    <div class="onOfff" style="margin-top: 7.5px; height: 30px">
                      <el-switch @change="changeSwitch" v-model="isPushMsg" active-color="#13ce66" inactive-color="#dfdfdf"></el-switch>
                      <span class="infoCallText">{{ isPushMsg == 0 ? '未开启' : '已开启' }}</span>
                    </div>
                  </div>
                </div>
                <div class="over_h lh40">
                  <div class="fl RealContent lh40" style="width: 80px">报警阈值</div>
                  <div class="fl infoCall">
                    ±
                    <el-input
                      v-model="leftItem.threshold"
                      type="number"
                      style="width: 52px; display: inline-block; margin-right: 4px; margin-left: 4px"
                      :disabled="!isPushMsg"
                      @keyup.enter.native="numberBlur(leftItem.threshold)"
                      @blur="numberBlur(leftItem.threshold)"
                    ></el-input
                    >%
                  </div>
                </div>
                <div class="over_h algoReco">
                  <div class="fl"></div>
                  <div v-if="areaBtnShow" class="fr editsb" @click="editCoordinate">识别区域</div>
                </div>
              </div>
            </div>
            <div class="fl tabCurContent over_h" style="width: 448px" v-if="leftIndex == 5">
              <div class="fl padd_lr20" v-if="detailInfo.algorithmMonitoringStatus != 1">
                <div class="over_h dateTitle">
                  <form class="layui-form">
                    <div class="layui-input-inline">
                      <el-date-picker
                        value-format="yyyy-MM-dd"
                        @change="changeForbid"
                        v-model="zcpdDate"
                        type="date"
                        placeholder="选择时间"
                      ></el-date-picker>
                    </div>
                  </form>
                </div>
                <div class="border borderZC">
                  <div
                    v-show="checkList.length > 0"
                    v-for="(item, i) in checkList"
                    :class="zcIndex == i ? 'on' : ''"
                    class="over_h"
                    @click="tabZc(i, item)"
                    :key="i"
                  >
                    <div class="fl">{{ item.createTime }}</div>
                    <div class="fr">{{ item.alarmCount === leftItem.value ? '最大' : item.alarmCount }}</div>
                  </div>
                  <div v-if="checkList.length < 1" style="line-height: 30px; text-align: left">暂未发现</div>
                </div>
              </div>
              <div class="fr" style="width: 238px; position: relative; height: 200px" v-if="detailInfo.algorithmMonitoringStatus != 1">
                <div class="over_h lh40">
                  <div class="fl RealContent lh40" style="width: 80px">盘点数量</div>
                  <div class="fl deviceNumber">{{ zcItem ? zcItem.checkCount : '0' }}</div>
                </div>
                <div class="over_h lh40" style="font-size: 14px">
                  <div class="fl RealContent lh40" style="width: 90px">静止时长设置</div>
                  <div class="fl typeInfo">
                    <el-input
                      v-model="leftItem.threshold"
                      type="number"
                      style="width: 52px; display: inline-block; margin-right: 4px; margin-left: 4px"
                      @keyup.enter.native="numberforbid(leftItem.threshold)"
                      @blur="numberforbid(leftItem.threshold)"
                    ></el-input
                    >分钟
                  </div>
                </div>
              </div>
            </div>
            <div
              class="fl tabCurContent over_h"
              style="width: 448px"
              v-if="leftIndex > 0 && leftIndex != 4 && leftIndex > 0 && leftIndex != 5"
            >
              <div class="fl padd_lr20">
                <div class="over_h dateTitle">
                  <el-date-picker v-model="jbyjDate" type="date" placeholder="选择时间"></el-date-picker>
                </div>
                <div style="line-height: 30px">暂未发现</div>
              </div>
              <div class="fr" style="width: 239px">
                <div class="lh_40 dateTitle text_C dateTitleC">今日异常情况</div>
                <div class="fs_14" style="margin-top: 5px">
                  <div class="over_h lh_30">暂未发现</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="coverImg viewer-images" v-if="tabHeadIndex == 1" :key="camera_index">
        <div class="videoCover_a">
          <easyplayerVideo :camera="camera"></easyplayerVideo>
        </div>
        <historyDate
          v-if="camera.deviceType != 3"
          style="margin-top: 20px"
          @change="changeHistory"
          :history_date="camera.history_date"
        ></historyDate>
      </div>
    </div>
    <div class="layuiMasks" v-if="editorDialog" :key="tabHeadIndex">
      <div class="layuiMaskBox">
        <div class="layuiMaskBoxTop">
          <div class="editTitle">设备编辑</div>
          <div class="layuiColse" @click="editorDialog = false"></div>
        </div>
        <div class="layuiMaskBoxBot">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="设备名称">
              <el-input v-model="form.deviceName"></el-input>
            </el-form-item>
            <el-form-item label="种类">
              <el-select v-model="form.type" placeholder="请选择种类" @change="changeType">
                <el-option label="其他" value="0"></el-option>
                <el-option label="羊" value="1"></el-option>
                <el-option label="猪" value="2"></el-option>
                <el-option label="牛" value="3"></el-option>
                <el-option label="驴" value="4"></el-option>
                <el-option label="鸡" value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="layuiBtns">
            <a class="confirm" @click="confrimEdit">确认</a>
            <a class="cancel" @click="editorDialog = false">取消</a>
          </div>
        </div>
      </div>
    </div>
    <div class="layuiMasks" style="width: 1320px; height: 850px; margin-top: 60px; z-index: 9999" v-if="dialogarea">
      <div class="layuiMaskBox" style="width: 1320px; height: 850px; z-index: 9999">
        <div class="layuiMaskBoxTop">
          <div class="editTitle">图片识别标注</div>
          <div class="layuiColse" @click="dialogarea = false"></div>
        </div>
        <div class="layuiMaskBoxBot">
          <div id="panel"></div>
          <div>
            <div class="canvasBLock" :style="{ backgroundImage: 'url(' + detailInfo.imgUrl + ')' }">
              <!-- <canvas id="canvas" width="800" height="450"></canvas> -->
              <!-- <img :src="detailInfo.imgUrl" > -->
              <div id="zrender-canvas" style="width: 1280px; height: 720px"></div>
            </div>
          </div>

          <canvas v-if="point" id="point" width="1280" height="720"></canvas>
          <div class="layuiBtns" style="margin-top: 10px">
            <a class="confirm" @click="confrimCoordinate">完成标注</a>
            <a class="cancel" @click="resetCoordinate">重置标注</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import lang_zhcn from 'video.js/dist/lang/zh-CN.json';
videojs.addLanguage('zh-CN', lang_zhcn);
import * as zrender from 'zrender';

import easyplayerVideo from '@/components/easyplayerVideo.vue';
import historyDate from '@/views/cattlesubsidy/components/historyDate.vue';

import noDataOrLoading from '@/components/module/noDataOrLoading/index.vue';
import breadcrumbModule from '@/components/module/breadcrumb/index.vue';
import paginationEL from '@/components/module/paginationEL/index.vue';
import tableTitleModule from '@/components/module/tableTitle/index.vue';
import {
  getDeviceAssociationsList,
  queryDeviceInfoV2,
  livingApi,
  checkMsg,
  upCameraDevice,
  getDeviceCheckCount,
  getStaticMonitoringList,
  openPushMsg,
  updateThreshold,
  getVideoPlayback,
  alarmlist,
  findDeviceCoordinate,
  updateCheckDevice
} from '../../api/device';
import searchTop from '@/components/module/searchTop/index.vue';

// 数据
import { pdaListNavData, resetOrSearch, pdaListTitleData } from '@/assets/data/smartAquacultureData.js';
export default {
  data() {
    return {
      resetOrSearch: resetOrSearch,
      tableTitleData: pdaListTitleData,
      camera: {
        title: [], // 非必填
        id: '', // 非必填（设备id）
        type: true, // 必填 true 实时播放 false 历史播放
        deviceNo: '', // 必填（设备号）
        history_date: [], // 历史播放必填（历史时间）
        deviceType: '', // 必填（设备类型）
        width: '615px', // 必填摄像头宽度
        height: '360px' // 必填摄像头高度
      },
      camera_index: 0,
      areaBtnShow: false,
      zr: null,
      group: null,
      clickIndex: 0,
      dataArr: [],
      dataArr1: [],
      //
      videohtml: '',
      videohtml1: '',
      // 识别区域
      dialogarea: false,
      point: false,
      coordinate: null,
      imgSrc: '',
      imgName: '',
      imgWidth: 0,
      imgHeight: 0,
      algoImgs: '',
      // 消息开关
      kaivalue: true,
      dialogFormVisible2: false,
      // 选项卡
      curId: 0,
      items: [
        {
          item: '实时画面'
        },
        {
          item: '历史录像'
        }
      ],
      contents: [],
      // 日历
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      valuedate: '',
      // 视频
      myHmVideo: {},
      // 时间选择器
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      video_title: '',
      state: '保育',
      //资产盘点
      check: '3',
      // 疾病预警
      illness: '已开通',
      // 体温监测
      temperature: '正常',
      // 繁殖优化
      breed: '已开通',
      dateTem: '',
      dialogVisible1: false,
      num: 2,
      dialogVisible: false,
      // dialog
      options: null,
      open: true,
      exit: false,
      fullscreen: false,
      tabPosition: 'left',
      ruleForm: {
        deviceName: '',
        livestockType: '',
        telType: '',
        aistatus: '',
        sbstatus: ''
      },
      diaFrom: {
        deviceName: '',
        livestockType: '',
        date: ''
      },
      total: 0,
      totalPage: 1,
      elementList: [],

      detail: null,
      active: 0,
      // 实时监控
      dialogTime: false,
      form: {
        deviceName: '',
        livestockType: '',
        id: '',
        type: ''
      },
      param: {
        deviceName: '',
        isAlarm: '',
        status: '0',
        current: 1,
        size: 20,
        farmId: '',
        isDevice: 1,
        sortType: 1
      },

      video_msg: [],
      // 直播数据
      living_msg: {},
      livingMsg: {},
      objer: {
        current: '1',
        size: '5'
      },
      formLabelWidth: '120px',
      renzhenobj: {
        createTime: '',
        deviceId: '',
        current: 1,
        size: 10
      },
      // 查看盘点信息
      InventoryHistory: {},
      tabHeadIndex: 0,
      leftIndex: 0,
      leftItem: null,
      zcpdDate: '',
      jbyjDate: '',
      detailInfo: {
        deviceName: ''
      },
      editorDialog: false,
      checkInfo: {
        createTime: '',
        deviceId: '',
        current: 1,
        size: 150
      },
      checkList: [],
      zcIndex: 0,
      zcItem: null,
      isPushMsg: 0, //0否  1是
      historyVideo: '',
      historyInfo: {
        current: 1,
        size: 50,
        readFlag: 2,
        alarmName: 'count' // 查监控数据
      },
      historyList: [],
      loadFlag: true,
      prevStatus: false,
      // options: {
      //   autoplay: false, // 设置自动播放
      //   controls: true, // 显示播放的控件
      // },
      myVideo: {},
      videoOptions: {
        autoplay: true, // 设置自动播放
        controls: true,
        controlBar: {
          // 设置控制条组件
          children: [
            {
              name: 'playToggle'
            }, // 播放按钮
            {
              name: 'currentTimeDisplay'
            }, // 当前已播放时间
            // {name: 'progressControl'}, // 播放进度条
            // {name: 'durationDisplay'}, // 总时间
            {
              name: 'FullscreenToggle'
            } // 全屏
          ]
        },
        language: 'zh-CN',
        // liveui: true,
        notSupportedMessage: '视频地址失效',
        hls: {
          withCredentials: true
        }
      },

      player: null,
      player1: null,
      errorMsg: null,
      coordinateInfo: {
        deviceId: ''
      },
      uodateCoordinateInfo: {
        deviceId: '',
        coordinate: '',
        remark: '1280,720'
      },
      coordinateCopy: '',
      deviceUrlInfo: {
        deviceId: ''
      },
      errShow: false,
      urlCount: 1,
      telecomUrl: '',
      // 当前loading
      curLoading: true,
      navData: pdaListNavData,
      layuiPlayerHeightJson: {},
      detailViewNewPlayer: {}
    };
  },
  components: {
    easyplayerVideo,
    historyDate,
    noDataOrLoading,
    breadcrumbModule,
    searchTop,
    paginationEL,
    tableTitleModule
  },
  created() {
    let date = new Date(),
      seperator1 = '-', //格式分隔符
      year = date.getFullYear(), //获取完整的年份(4位)
      month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
      strDate = date.getDate(); // 获取当前日(1-31)
    if (month >= 1 && month <= 9) month = '0' + month; // 如果月份是个位数，在前面补0
    if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate; // 如果日是个位数，在前面补0
    this.checkInfo.createTime = year + seperator1 + month + seperator1 + strDate;
    const detailId = this.$route.params && this.$route.params.detailId;
    this.detailId = detailId;
    this.livingMsg = JSON.parse(localStorage.getItem('info'));
    this.getList();
    // this.getLiving();
    // this.getCheckMsg()

    let start = dayjs(new Date()).add('-1', 'days').format('YYYY-MM-DD HH:00:00');
    let end = dayjs(new Date()).add('-1', 'days').format('YYYY-MM-DD HH:59:59');
    this.camera.history_date = [start, end];
  },
  mounted() {
    const that = this;
    this.getHistory();
    setTimeout(() => {
      that.layuiPlayerHeight();
    }, 500);
  },
  methods: {
    // 搜索 / 重置事件
    searchEvent(item) {
      this[item.event]('ruleForm');
    },
    handlePreview() {
      this.$refs.preview.clickHandler();
    },
    previewSrclist(url) {
      var list = [];
      list.push(url);
      return list;
    },
    downloadFlexFlow() {},
    layuiPlayerHeight() {
      const that = this;
      this.$nextTick(() => {
        let _height = document.getElementsByClassName('pdaModule')[0];
        let _clientH = (_height.clientWidth / 5) * 0.5;
        that.layuiPlayerHeightJson = {
          height: _clientH + 'px'
        };
        that.detailViewNewPlayer = {
          'max-height': _clientH + 130 + 'px'
        };
        // setTimeout(() => {
        //   let _height = document.getElementsByClassName('pdaModule')[0];
        //   let _clientH = _height.clientHeight / 5 * 1.2;
        //   that.layuiPlayerHeightJson = {
        //     height: _clientH + 'px'
        //   }
        //   that.detailViewNewPlayer = {
        //     'max-height': _clientH + 130 + 'px'
        //   }
        // }, 500);
      }, 500);
    },
    changeHistory(start_date, end_date) {
      this.camera_index++;
      this.camera.history_date = [start_date, end_date];
    },
    handleSizeChange(val) {
      this.param.current = 1;
      this.param.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.param.current = val;
      this.getList();
    },
    numberBlur(number) {
      if (number) {
        if (number >= 1 && number <= 100) {
          openPushMsg({
            algoType: this.leftIndex,
            deviceId: this.detailInfo.id,
            threshold: number
          }).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '报警阈值设置成功!'
              });
            } else {
              this.$message({
                type: 'success',
                message: '报警阈值设置失败!'
              });
            }
          });
        } else {
          this.$message({
            type: 'info',
            message: '请输入0~100之间的数字',
            duration: 2000
          });
        }
      }
    },
    numberforbid(number) {
      if (number) {
        if (number > 0 && number <= 99999) {
          updateThreshold({
            algoType: this.leftIndex,
            deviceId: this.detailInfo.id,
            threshold: number
          }).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '静止时长设置成功!'
              });
            } else {
              this.$message({
                type: 'success',
                message: '静止时长设置失败!'
              });
            }
          });
        } else {
          this.$message({
            type: 'info',
            message: '请输入0~99999之间的数字',
            duration: 2000
          });
        }
      }
    },
    imgError(e, item, index) {
      item.imgUrl = 'https://weimuyun-h5.oss-cn-hangzhou.aliyuncs.com/images/imgError.png';
    },
    imgError1(e, item, index) {
      item.videoThumb = 'https://weimuyun-h5.oss-cn-hangzhou.aliyuncs.com/images/imgError.png';
    },
    imgPlayBtn(item) {
      if (!item.play_status) {
        this.$set(item, 'videoSrc', item.imgUrl);
        item.type = true;
        item.width = '100%'; // 必填摄像头宽度
        item.height = '100%'; // 必填摄像头高度
      }
    },
    detailApi(param, deviceType, item) {
      detailApi(param).then(res1 => {
        if (deviceType == 9) {
          this.$set(item, 'videoSrc', 'https://h265.xiaomuding.com/?url=' + res1.data.data.liveHdAddress);
        } else if (deviceType == 3) {
          this.$set(item, 'videoSrc', res1.data.data.liveHdAddress);
        } else {
          videojs.hook('error', (player, err) => {
            this.errorMsg = err;
            this.video_msg[i].errshow = true;
          });
          videojs('myVideo' + item.id, {
            width: 298,
            height: 170,
            autoplay: true, // 设置自动播放
            controls: true,
            controlBar: {
              // 设置控制条组件
              children: [
                {
                  name: 'playToggle'
                }, // 播放按钮
                {
                  name: 'currentTimeDisplay'
                }, // 当前已播放时间
                {
                  name: 'progressControl'
                }, // 播放进度条
                {
                  name: 'durationDisplay'
                }, // 总时间
                {
                  name: 'FullscreenToggle'
                } // 全屏
              ]
            }
          }).src([
            {
              // src: 'https://open.ys7.com/v3/openlive/F77617353_1_1.m3u8?expire=1667145624&id=504444013168828416&t=38d46f4fb85bffddcb8edfe2dcc2b8b781dd9e3ff5c0c5d04662194ccfeaab4a&ev=100',
              src: res1.data.data.hlsAddressUrl,
              type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
            }
          ]);
        }
      });
    },
    // 识别区域
    async editCoordinate() {
      this.dataArr = [];
      this.dialogarea = true;
      this.coordinateInfo.deviceId = this.detailInfo.id;
      this.coordinateInfo = {
        deviceId: this.detailInfo.id,
        algoType: this.leftIndex
      };
      findDeviceCoordinate(this.coordinateInfo).then(res => {
        this.coordinate = res.data.data.coordinate;
        this.coordinateCopy = res.data.data.coordinate;
        if (this.coordinate != null) {
          this.point = true;
          let canvasHeight = 720,
            canvasWidth = 1280;
          let positions = [];
          let dataArr1 = this.coordinate.split(',');
          for (let i = 0; i < dataArr1.length; i++) {
            this.dataArr.push(Math.round(dataArr1[i] / this.urlCount));
            positions.push(Math.round(dataArr1[i] / this.urlCount));
          }
          // dataArr1.forEach(item=>{
          //   item = Math.round(item/2)  716, 22, 180, 258, 854, 546, 1004, 75
          // })
          // this.dataArr = dataArr1
          // canvas元素对应的宽高

          // 进行一系列处理，目的是得到各个方向轴的最大最小值，朋友们的处理方式应该和我不同
          let amuArr = positions;
          let amuXArr = amuArr.filter((_, index) => {
            return index % 2 == 0;
          });

          let amuYArr = amuArr.filter((_, index) => {
            return index % 2 != 0;
          });
          // 注意：y轴需要进行取负操作
          // .map((item) => {
          // 	return item * -1;
          // });

          // 拿到方向轴的最大最小值
          let xMax = Math.max(...amuXArr);
          let xMin = Math.min(...amuXArr);
          let yMax = Math.max(...amuYArr);
          let yMin = Math.min(...amuYArr);
          this.$nextTick(() => {
            let canvasP = document.getElementById('point');
            let ctx = canvasP.getContext('2d');
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            // 由于canvas坐标轴与经纬度不相同，所以需要平移原点并旋转画布
            // ctx.translate(0, canvasHeight);
            // ctx.rotate(-Math.PI / 2);
            ctx.beginPath();

            // 根据偏移量移动点位并画图
            ctx.moveTo(amuXArr[0], amuYArr[0]);
            for (let i = 1; i < amuXArr.length; i++) {
              ctx.lineTo(amuXArr[i], amuYArr[i]);
            }
            ctx.closePath();
            ctx.strokeStyle = '#7FFF00';
            ctx.lineWidth = 3;
            ctx.stroke();
          });
        }
      });

      // this.coordinate = this.detailInfo.coordinate
      // this.coordinate = "286,227,281,383,607,410,469,205,285,227";

      // canvas点

      let that = this;
      that.$nextTick(() => {
        let mycanvas = document.getElementById('zrender-canvas');
        that.zr = zrender.init(document.getElementById('zrender-canvas'));
        that.group = new zrender.Group();
        var image = new Image();
        image.src = that.detailInfo.imgUrl;
        image.onload = function () {
          that.imgWidth = '1280';
          that.imgWidth = '720';
          that.imgWidth = that.detailInfo.imgUrl;
          that.imgWidth = 'AlgoImg';
          that.addImg();
          that.zr.add(that.group);
          that.initData();
        };
        that.zr.add(that.group);

        mycanvas.onclick = function (e) {
          if (that.coordinateCopy) {
            that.$message({
              type: 'info',
              message: '请先重置标注!'
            });
          } else {
            e.preventDefault();
            let pointX = e.offsetX;
            let pointY = e.offsetY;
            that.addPoint(pointX, pointY);
            that.zr.add(that.group);

            that.addData(pointX, pointY);
            that.zr.add(that.group);
            if (that.clickIndex) {
              that.addLine(that.dataArr1[that.clickIndex - 1], that.dataArr1[that.clickIndex]);
              that.zr.add(that.group);
            }
            that.clickIndex++;
          }
        };
      });
    },
    confrimCoordinate() {
      if (!this.dataArr.length) {
        alert('请先标注');
        return;
      }
      this.uodateCoordinateInfo.deviceId = this.detailInfo.id;
      var dataArrj = this.dataArr;
      var dataArrx = [];
      for (var k = 0; k < dataArrj.length; k++) {
        dataArrj[k] = Math.round(dataArrj[k] * this.urlCount);
        dataArrx.push(dataArrj[k]);
      }
      this.uodateCoordinateInfo.coordinate = dataArrx.join(',');
      this.uodateCoordinateInfo.algoType = 4;

      updateCheckDevice(this.uodateCoordinateInfo).then(res => {
        this.dialogarea = false;
      });
    },
    resetCoordinate() {
      this.group = new zrender.Group(); // 重构画布
      this.zr.clear();
      this.initData();
      this.coordinate = '';
      this.coordinateCopy = '';
      let canvasP = document.getElementById('point');
      let ctx = canvasP.getContext('2d');
      ctx.clearRect(0, 0, 1280, 720);
    },
    initData() {
      this.dataArr = [];
      this.dataArr1 = [];
      this.clickIndex = 0;
    },

    addImg() {
      let imgPig = new zrender.Image({
        style: {
          image: this.detailInfo.imgUrl,
          x: 0,
          y: 0,
          width: this.imgWidth,
          height: this.imgHeight
        }
      });
      this.group.add(imgPig);
    },
    // 添加点
    addPoint(x = 0, y = 0) {
      let circle = new zrender.Circle({
        shape: {
          cx: x,
          cy: y,
          r: 8
        },
        style: {
          fill: '#7FFF00',
          stroke: '#7FFF00'
        }
      });

      circle.animateTo(
        {
          //不需要再手动调用start()，可写多个属性
          shape: {
            r: 10
          }
        },
        100
      );

      this.group.add(circle);
    },
    // 添加线
    addLine(point1, point2) {
      var line = new zrender.Line({
        shape: {
          x1: point1[0],
          y1: point1[1],
          x2: point2[0],
          y2: point2[1]
        },
        style: {
          stroke: '#FF0000',
          lineWidth: 4
        }
      });
      this.group.add(line);
    },
    // 添加数据
    addData(x, y) {
      let that = this;
      that.dataArr.push(x, y);
      that.dataArr1.push([x, y]);
    },
    prevClick() {
      if (this.param.current > 1) {
        this.prevStatus = true;
        this.param.current -= 1;
        if (this.param.current == 1) {
          this.prevStatus = false;
        }
        this.getList();
      } else {
        this.param.current = 1;
        this.prevStatus = false;
      }
    },
    nextClick() {
      if (this.loadFlag) {
        this.param.current += 1;
        this.getList();
      }
      if (this.param.current > 1) {
        this.prevStatus = true;
      }
    },
    getHistory() {
      alarmlist(this.historyInfo).then(res => {
        this.historyList = res.data.data.records;
      });
    },
    isAlert() {
      // this.param.isAlarm = 1
      // this.param.page = 1
      // this.getList()
    },
    backVideo() {
      this.videohtml1 = '<video class="  video-js vjs-big-play-centered  vjs-default-skin" id="myVideoEoo" controls="controls"></video>';

      this.player1 = null;
      let param = {
        deviceNo: this.detailInfo.deviceNo,
        endTime: this.checkInfo.createTime + ' 23:59:59',
        startTime: this.checkInfo.createTime + ' 00:00:00'
      };
      getVideoPlayback(param).then(res => {
        this.historyVideo = res.data.data;
        this.$nextTick(res => {
          videojs.hook('error', (player, err) => {
            this.errShow = true;
            this.errorMsg = err;
          });
          setTimeout(() => {
            this.getVideo1(this.historyVideo.data);
          }, 300);
        });

        // this.videoShow1()
      });
    },

    // 消息开关
    changeSwitch(e) {
      let algoType = e == true ? '1' : '0';
      let param = {
        algoType: algoType,
        deviceId: this.detailInfo.id
      };
      openPushMsg(param).then(res => {
        if (e) {
          this.$message({
            type: 'success',
            message: '消息提醒已开启!'
          });
        } else {
          this.$message({
            type: 'success',
            message: '消息提醒已关闭!'
          });
        }
      });
    },
    changezcpd(e) {
      this.zcItem = null;
      this.checkList = [];
      this.checkInfo.createTime = e;
      this.checkCount(this.checkInfo);
    },
    changeForbid(e) {
      this.zcItem = null;
      this.checkList = [];
      this.checkInfo.createTime = e;
      this.getStaticMonitoringList(this.checkInfo);
    },
    tabZc(i, item) {
      this.zcIndex = i;
      this.zcItem = item;
    },
    changeType(e) {
      this.form.livestockType = e;
    },
    editClick() {
      this.editorDialog = true;
      this.form.deviceName = this.detailInfo.deviceName;
      this.form.id = this.detailInfo.id;
      this.form.livestockType = this.detailInfo.livestockType;
      if (this.detailInfo.livestockType == 0) {
        this.form.type = '其他';
      }

      if (this.detailInfo.livestockType == 1) {
        this.form.type = '羊';
      }
      if (this.detailInfo.livestockType == 2) {
        this.form.type = '猪';
      }
      if (this.detailInfo.livestockType == 3) {
        this.form.type = '牛';
      }
      if (this.detailInfo.livestockType == 4) {
        this.form.type = '驴';
      }
      if (this.detailInfo.livestockType == 5) {
        this.form.type = '鸡';
      }
    },
    confrimEdit() {
      upCameraDevice(this.form).then(res => {
        this.editorDialog = false;
        this.dialogVisible1 = false;
        this.getList();
        this.$message({
          type: 'success',
          message: '修改成功!'
        });
      });
    },
    // 今日盘点列表
    checkCount(checkInfo) {
      this.zcItem = '';
      getDeviceCheckCount(checkInfo).then(res => {
        if (res.data.data.records.length > 0) {
          this.checkList = res.data.data.records;
          this.checkList.forEach(item => {
            item.createTime = item.createTime.substring(11, item.createTime.length);
          });
          if (this.checkList.length > 0) {
            this.zcItem = this.checkList[0];
          }
        } else {
          this.checkList = [];
        }
      });
    },
    // 监测列表
    getStaticMonitoringList(checkInfo) {
      getStaticMonitoringList(checkInfo).then(res => {
        if (res.data.data.records.length > 0) {
          this.checkList = res.data.data.records;
          this.checkList.forEach(item => {
            item.createTime = item.createTime.substring(11, item.createTime.length);
          });
          this.zcItem = this.checkList[0];
        } else {
          this.zcItem = null;
          this.checkList = [];
        }
      });
    },
    tabLeft(item) {
      this.leftIndex = item.algorithmType;
      this.leftItem = item;
      if (item.algorithmType == 4) {
        this.checkCount(this.checkInfo);
      }
      if (item.algorithmType == 5) {
        this.getStaticMonitoringList(this.checkInfo);
      }
    },
    tabHeader(i) {
      this.tabHeadIndex = i;
      if (i == 1) {
        this.camera.deviceNo = this.detailInfo.deviceNo;
        this.camera.id = this.detailInfo.id;
        this.camera.type = false;
        this.camera.deviceType = this.detailInfo.deviceType;
      } else {
        this.camera.deviceNo = this.detailInfo.deviceNo;
        this.camera.id = this.detailInfo.id;
        this.camera.type = true;
        this.camera.deviceType = this.detailInfo.deviceType;
      }
    },
    closeDialog() {
      if (this.player != null) {
        this.player.dispose();
      }
      if (this.player1 != null) {
        this.player1.dispose();
      }

      this.videohtml = '';
      this.videohtml1 = '';
      this.editorDialog = false;
      this.dialogVisible1 = false;
    },
    toDetail(item) {
      this.errShow = false;
      if (item.algorithmMonitoringStatus == 0) {
        this.areaBtnShow = true;
      } else {
        this.areaBtnShow = false;
      }
      this.videohtml = '<video class="video-js vjs-big-play-centered  vjs-default-skin" id="myVideo" controls="controls"></video>';
      this.player = null;
      this.tabHeadIndex = 0;
      this.leftIndex = 0;
      let param = {};
      param = {
        deviceId: item.id,
        protocol: '2'
      };
      queryDeviceInfoV2(param).then(res => {
        this.detailInfo = res.data.data;
        if (this.detailInfo.algorithmTypeVoList) {
          this.detailInfo.algorithmTypeVoList.unshift({
            algorithmName: '实时画面',
            algorithmStatus: '',
            algorithmType: 0,
            endTime: '',
            isMonitor: '',
            isPushMsg: '',
            startTime: '',
            threshold: '',
            value: ''
          });
        }
        this.dialogVisible1 = true;
      });
      this.checkInfo.deviceId = item.id;
      // this.checkCount(this.checkInfo);
      this.camera.deviceNo = item.deviceNo;
      this.camera.id = item.id;
      this.camera.type = true;
      this.camera.deviceType = item.deviceType;
    },

    // 关闭查看详情dialog
    ai_dialog_close() {
      //关闭弹框
      this.dialogTableVisible = false;
    },
    // 选项卡
    tab(index) {
      this.curId = index;
    },
    // 模态框更换背景
    chage(index) {
      this.active = index;
    },
    // 搜索设备

    // dialog关闭

    handleClose1(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 重置
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.param.deviceName = '';
      this.param.isAlarm = '';
      this.param.status = '0';
      this.param.current = '1';
      this.param.size = 20;
      this.getList();
    },
    submitForm(formName) {
      this.param.isAlarm = '';
      this.param.current = 1;
      this.getList();
    },
    getList() {
      this.param.farmId = localStorage.getItem('farmIdear');
      this.curLoading = true;
      getDeviceAssociationsList(this.param)
        .then(res => {
          this.curLoading = false;
          this.elementList = res.data.data.records;
          if (this.elementList.length < this.param.size) {
            this.loadFlag = false;
          } else {
            this.loadFlag = true;
          }
          this.total = res.data.data.total;
          if (res.data.data.records.length > 0) {
            res.data.data.records.forEach(item => {
              this.$set(item, 'imgPlay', false);
              this.$set(item, 'errshow', false);
              if (item.openAlgo) {
                if (item.openAlgo.indexOf('4') > -1) {
                  item.openAlgo = true;
                } else {
                  item.openAlgo = false;
                }
              } else {
              }
            });
          }

          this.video_msg = res.data.data.records;

          this.video_title = res.data.data.records.deviceName;
        })
        .catch(() => {
          this.curLoading = false;
        });
    },

    // 查看设备当天盘点历史   资产盘点
    choseDate(item) {
      this.renzhenobj.deviceId = item.id;
      this.dialogVisible1 = true;
      checkMsg(this.renzhenobj).then(res => {
        this.InventoryHistory = res;
      });
    },

    // 直播数据  暂无数据
    getLiving() {
      (this.objer.id = this.livingMsg.userId),
        livingApi(this.objer).then(res => {
          this.living_msg = res;
        });
    },
    // 页码
    // currentPages(e) {
    //   this.loading = true
    //   this.param.page = e
    //   this.getList()
    // },
    prev(e) {
      this.loading = true;
      this.param.current = e;
      this.getList();
    },
    next(e) {
      this.loading = true;
      this.param.current = e;
      this.getList();
    },
    handleChange(item) {
      let cityList = this.$refs['city'].getCheckedNodes()[0].pathLabels;
      this.form.cityName = cityList[1];

      this.form.provinceName = cityList[0];
      if (cityList[2] == '全部地区') {
        this.form.countyName = '';
      } else {
        this.form.countyName = cityList[2];
      }
      if (cityList[1] == '全部市区') {
        this.form.cityName = '';
      } else {
        this.form.cityName = cityList[2];
      }
    },
    onSubmit() {
      this.getList();
    }
  }
};
</script>

<style scoped="scoped">
@import url('../../assets/CSS/admin.css');
.infoDatas {
  /* display: flex; */
}
.infoDatas-flex {
  width: 50%;
  float: left;
}
.infoDatas > div > div {
  width: 100%;
}

/* 选项卡样式 */
#tab {
  position: relative;
  top: -20px;
  left: 230px;
  width: 200px;
  background-color: #ccc;
  border: 1px solid #ccc;
  margin: 60px auto 0;
}

.titles {
  display: flex;
}
.titles-name {
  width: 200px;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

/deep/ .infoCall .el-input__inner {
  height: 30px !important;
}

.tab-bar {
  width: 400px;
  background-color: #ccc;
}

.tab-bar a {
  float: left;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
  color: #000;
}

.tab-bar .active {
  background-color: white;
  border-radius: 5px;
}

.tab-con div {
  text-align: left;
  height: 100px;
}

.index {
  height: 100%;
  text-align: center;
  box-sizing: border-box;
}

.activeClass1 {
  background-color: #fff;
}

/* 内容区域 */
.video_box > .second_row > div > p > span {
  color: rgba(167, 197, 48);
}

.video_box .img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.video_box > .title {
  position: relative;
  top: -26px;
  right: 100px;
  font-weight: bold;
}

.video_box > .first_row {
  display: flex;
  position: relative;
  top: -95px;
  justify-content: space-between;
  margin: 20px;
}

.video_box > .first_row > .state {
  background-color: rgba(239, 239, 240);
  height: 25px;
  line-height: 25px;
  width: 70px;
  color: grey;
  font-size: 15px;
  border-radius: 3px;
}

.second_row > .anthor {
  background-color: rgba(245, 245, 245);
  height: 40px;
  display: flex;
  justify-content: center;
  line-height: 40px;
  width: 100px;
  margin-left: 2%;
  border-radius: 5px;
}

.second_row > .anthor > .zero {
  font-weight: bold;
  position: relative;
  top: -15px;
  left: 5px;
}

/* .layuiPdaList {
  height: calc(100vh - 384px);
  overflow-y: auto;
}

@media (max-width: 1500px) {
  .layuiPdaList {
    height: calc(100vh - 445px);
  }
} */

.title {
  height: 60px;
  line-height: 60px;
  margin: 0;
}

.title h3 {
  margin: 0 !important;
}

.title h3 span {
  font-weight: normal;
  font-size: 16px;
  margin-left: 10px;
}

.el-main {
  background: #f7f7f7 !important;
}

.pdaBoxs {
  /* background: #fff; */
  /* padding: 20px 20px 10px 20px; */
  /* padding: 20px; */
  box-sizing: border-box;
  height: calc(100% - 60px);
  display: flex;
  flex-flow: column;
}

.oul li {
  float: left;
  margin: 0px 20px 20px 0;
  font-size: 16px;
  width: 320px;
  height: 320px;
  color: #333;
  transition: all 0.3s;
  position: relative;
  padding: 0;
  line-height: inherit;
  border-radius: 5px;
  border: 1px solid #eee;
}

.oul li > .imgCover {
  width: 318px;
  height: 180px;
  cursor: pointer;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  overflow: hidden;
}

.imgCover .img {
  width: 318px !important;
  height: 180px !important;
  cursor: pointer;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  overflow: hidden;
}

.imgCover .img > img {
  width: 318px;
  height: 180px;
}

.imgCover .img > video {
  width: 318px;
  height: 180px;
}

.info {
  padding: 0 !important;
}

.info > .name {
  display: flex;
  margin-top: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.info > .names {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  margin-top: 5px;
}

.opration {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  height: 28px;
  align-items: center;
}

.opration > div:nth-child(1) {
  padding: 0 20px;
  height: 28px;
  line-height: 28px;
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  font-size: 14px;
  color: #666666;
  border: solid 1px #f5f5f5;
}

.opration > div:nth-child(2) {
  padding: 0 10px;
  height: 28px;

  line-height: 28px;
  border-radius: 4px;
  font-size: 14px;
  color: #666666;
  border: solid 1px #d9d9d9;
}

.NumberCover {
  width: 100%;
  margin-top: 10px;
}

.NumberCover > div {
  float: left;
  width: 50%;
  line-height: 30px;
}

.NumberCover > div:nth-child(2n) {
  text-align: right;
}

.address {
  color: #999;
}

.address > img {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.users {
  font-weight: 700;
}

.users > img {
  margin-right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.userID {
  margin-left: 15px;
  font-weight: normal !important;
  color: #999;
}

.liveW {
  padding: 3px 5px;
  background: rgba(245, 245, 245, 1);
  color: #333;
  border-radius: 5px;
  font-size: 12px;
  margin-left: 10px;
}

.aiAb {
  position: absolute;
  top: 0;
  left: 0;
}

.aiAb img {
  position: absolute;
  z-index: 99;
}

.aiAb span {
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 40px;
  position: absolute;
  z-index: 99;
}

.aiAb.open {
  width: 140px;
  height: 60px;
}

.aiAb.open:after {
  content: '';
  position: absolute;
  left: -5px;
  top: -5px;
  width: 140px;
  height: 60px;
  background: url(../../assets/img/opaibg.svg) no-repeat center;
  background-size: cover;
  opacity: 0.9;
}

.aiAb.open img {
  width: 44px;
  height: 38px;
}

.aiAb.open span {
  color: rgba(0, 0, 0, 0.996078431372549);
  left: 55px;
}

.aiAb.unnormal {
  width: 120px;
  height: 40px;
}

.aiAb.unnormal:after {
  content: '';
  position: absolute;
  width: 120px;
  height: 40px;
  background: -webkit-linear-gradient(180deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  background: -moz-linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  background: linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  border: none;
  border-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: 5px 5px 10px rgba(217, 0, 27, 0.498039215686275);
  -webkit-box-shadow: 5px 5px 10px rgba(217, 0, 27, 0.498039215686275);
  box-shadow: 5px 5px 10px rgba(217, 0, 27, 0.498039215686275);
}

.aiAb.unnormal img {
  width: 24px;
  height: 18px;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.aiAb.unnormal span {
  color: #fff;
  left: 65px;
}

.aiAb.unopen {
  width: 120px;
  height: 40px;
}

.aiAb.unopen:after {
  content: '';
  position: absolute;
  width: 120px;
  height: 40px;
  opacity: 0.6;
  background-color: rgba(0, 0, 0, 1);
  -moz-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.247058823529412);
  -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.247058823529412);
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.247058823529412);
}

.aiAb.unopen img {
  width: 24px;
  height: 18px;
  left: 10px;
  opacity: 0.6;
  top: 0;
  bottom: 0;
  margin: auto;
}

.aiAb.unopen span {
  color: #fff;
  opacity: 0.6;
  left: 55px;
}

/* 视频样式 */
.video_box {
  /* display: inline-block; */
  float: left;
  width: 23%;
  margin-right: 1.5%;
  height: 380px;
  margin-bottom: 2%;
  text-align: center;
  /* line-height: 100px; */
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  /* margin-right: 4px; */
}

.listPdas {
  overflow-y: auto;
  /* height: 600px; */
  /* flex: 1; */
}

.nullOrLoading {
  flex: 1;
}

.pdaBoxs {
  min-width: 1200px;
  /* overflow: auto; */
}

.dateTitle .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #30bf30 !important;
}

/deep/ .el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: auto;
}

/deep/ .currentHls #myVideo {
  width: 615px !important;
  height: 360px !important;
}

.layuiMaskBoxBot {
  position: relative;
}

canvas {
  position: absolute;
  width: 1280px;
  height: 720px;
  left: 20px;
  top: 0;
}

#zrender-canvas {
  position: absolute;
  width: 1280px;
  height: 720px;
  left: 20px;
  top: 0;
  z-index: 1;
}

.detailViewNews {
  /* max-height: 300px; */
  /* margin: 10px 20px 0 0; */
}

.canvasBLock {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 1280px;
  height: 720px;
  margin-left: 20px;
  background-size: 100% 100%;
}

.zcItem_checkImg {
  position: absolute;
  left: -1000%;
}

.onOfff {
  display: flex;
  align-items: center;
}

/deep/ .size_a {
  position: absolute;
  bottom: 68px;
  left: 49%;
  width: 280px;
  z-index: 4;
  cursor: pointer;
}

.size_a > div {
  background: #fff;
}

/deep/ .vjs-error .vjs-error-display:before {
  display: none !important;
}

/deep/ .vjs-loading-spinner {
  display: none !important;
}

/deep/ .videoCover_a .video-js .vjs-modal-dialog {
  display: none !important;
}

/deep/ .vjs-modal-dialog-content {
  padding: 40px 24px !important;
}

/deep/ .videoCover_a .vjs-big-play-button {
  display: none !important;
}

.errstyle1 {
  text-align: center;
  line-height: 170px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.errstyle {
  text-align: center;
  line-height: 360px;
  color: #fff;
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
}

.el-empty {
  padding: 150px 0 !important;
}

.buton {
  background: #f6f7fb;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  padding: 10px 0px 16px 20px;
}

/deep/.el-button--default:active,
.el-button--default:focus {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
}

/deep/ .el-button--default:hover {
  background: transparent !important;
  border-color: #c1ecc1 !important;
  color: #30bf30 !important;
}

/deep/ .vjs-modal-dialog-content {
  display: none !important;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
<style scoped>
/deep/ .video-js .vjs-fullscreen-control {
  position: absolute !important;
  right: 0 !important;
  z-index: 11 !important;
}
</style>

<style lang="scss">
@import '../../assets/scss/index.scss';
.listDisplayFlex {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
}
.detailViewNews {
  width: calc(20% - 12px);
  box-sizing: border-box;
  padding: $spacing;
  margin-bottom: $spacing;
  border-radius: $borderRdius;
  position: relative;
  cursor: pointer;
  margin-right: $spacing;
  border: 1px solid $borderColor;
  &:nth-child(5n) {
    margin-right: 0;
  }
  &:hover {
    background: $backColor;
  }
  .imgVideo {
    height: 170px;
  }
  div {
    box-sizing: border-box;
  }
}

.itemOnDuty {
  width: 120px;
  height: 40px;
  background: -webkit-linear-gradient(180deg, rgba(255, 149, 0, 1) 0%, rgba(255, 225, 76, 1) 100%);
  position: absolute;
  top: 15px;
  left: 15px;
  section {
    display: flex;
    span {
      color: rgba(0, 0, 0, 0.996078431372549);
      display: inline-block;
      font-size: $fontSize;
      line-height: 40px;
      padding-left: 5px;
      font-size: 16px;
    }
  }
}
.itemOnDutyNull {
  background: rgba(0, 0, 0, 0.5);
  section {
    display: flex;
    img {
      width: 24px;
      height: 18px;
      margin-left: 10px;
      margin-top: 10px;
    }
    span {
      color: white;
      display: inline-block;
      font-size: $fontSize;
      line-height: 40px;
      padding-left: 18px;
      font-size: 16px;
    }
  }
}
.itemOnDutyErr {
  background: linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
  section {
    display: flex;
    img {
      width: 24px;
      height: 18px;
      margin-left: 10px;
      margin-top: 10px;
    }
    span {
      color: white;
      display: inline-block;
      font-size: $fontSize;
      line-height: 40px;
      padding-left: 18px;
      font-size: 16px;
    }
  }
}
// .itemOnDuty {
//   width: 120px;
//   height: 40px;
//   background: -webkit-linear-gradient(180deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
//   position: absolute;
//   top: 15px;
//   left: 15px;
//   // border-top-right-radius: 30px;
//   // border-bottom-right-radius: 30px;
//   section {
//     display: flex;
//     img {
//     }
//     span {
//       color: rgba(0, 0, 0, 0.996078431372549);
//       display: inline-block;
//       font-size: $fontSize;
//       line-height: 40px;
//       padding-left: 5px;
//       font-size: 14px;
//     }
//   }
// }
</style>


// WEBPACK FOOTER //
// src/views/pdaList/pdaList.vue